module.exports = __webpack_public_path__ + "img/default.07b655b4.jpeg";